<h1 matDialogTitle>
  <ng-container>Edit {{data.firstName}} {{data.lastName}} Permissions</ng-container>
</h1>
<mat-dialog-content>

  <aw-user-permissions-form [user]="data" (done)="dialogRef.close(true)"></aw-user-permissions-form>

</mat-dialog-content>
